import CityAPI from 'api/city';
import AirportAPI from 'api/airport';
import {Page} from 'router/page';
import {foldWithSearchState, parseSlug} from './utils';
import {loadable} from 'router/routes';

const MidFunnelAirport = loadable(() =>
    import('mid-funnel/airport/MidFunnelAirport')
);

MidFunnelAirport.getInitialState = async ({state, params}) => {
    const citySlug = params.city;
    const {data: city} = await CityAPI.get(citySlug);
    const slug = parseSlug(params.slug);
    const destination = await AirportAPI.getBySlug(slug).then(res => res.data);

    const {
        data: {timezone},
    } = city;

    const {
        data: {latitude, longitude},
    } = destination;

    return foldWithSearchState({
        state: {...state, city, destination},
        type: Page.AIRPORT,
        latitude,
        longitude,
        timezone,
    });
};

export default MidFunnelAirport;
